import React, { FunctionComponent } from "react";
import { rightUtils } from "utils/business/rightUtils";
import FlexBox from "components/atoms/flex/FlexBox";
import { FlexAttributValue } from "types/flex/flex";
import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Switch } from "components/atoms/switch/Switch";
import { User } from "interfaces/user/user";

interface DistributorModeToggleProps {
  user: User;
  onChangeDistributionMode: (boolean) => void;
  distributionMode: boolean;
}

export const DistributorModeToggle: FunctionComponent<DistributorModeToggleProps> = ({
  user,
  onChangeDistributionMode,
  distributionMode,
}) => {
  return (
    rightUtils.isAdmin(user) && (
      <FlexBox flexDirection={FlexAttributValue.ROW} marginTop={1}>
        <Typography marginRight={1} fontWeight="bold" className="uppercase">
          <FormattedMessage id="distributor_toggle" />
        </Typography>
        <Switch onChange={(e, checked) => onChangeDistributionMode(checked)} checked={distributionMode} />
      </FlexBox>
    )
  );
};
